module.exports = __webpack_public_path__ + "static/img/编组 5.cb70d11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hz/编组 5.png
// module id = GTp4
// module chunks = 1